"use strict";
//******************************************************************************
// Copyright 2018-2020, ShareSquared Inc., All Rights Reserved.
//
// Author:  Ted Iverson
// Created: 08/21/2020
//
// The contents of this file are proprietary and considered trade secret.
// Any disclosure outside of its intended use is expressly prohibited.
//******************************************************************************
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
//#region Imports
var React = require("react");
require("jquery/src/jquery");
var Label_1 = require("@fluentui/react/lib/Label");
var Button_1 = require("@fluentui/react/lib/Button");
var DatePicker_1 = require("@fluentui/react/lib/DatePicker");
var TextField_1 = require("@fluentui/react/lib/TextField");
var Dropdown_1 = require("@fluentui/react/lib/Dropdown");
var react_bootstrap_1 = require("react-bootstrap");
var Spinner_1 = require("@fluentui/react/lib/Spinner");
var react_1 = require("@fluentui/react");
var RequestForm = /** @class */ (function (_super) {
    __extends(RequestForm, _super);
    function RequestForm(props, state) {
        var _this = _super.call(this, props, state) || this;
        // tracks the properties of each field on the form so we can have the information
        // during the building of the query (mainly Type and Mapped Property)
        _this.formFieldProps = new Map();
        _this.state = { FormValues: {}, InvalidControlIds: new Map(), Processing: false, Submitted: false };
        return _this;
    }
    RequestForm.prototype.renderField = function (field, idx) {
        var _this = this;
        var f;
        switch (field.fieldType.toLowerCase()) {
            default:
            case "text": {
                var id_1 = "ftxt_" + idx;
                this.formFieldProps.set(id_1, { Id: id_1, Type: field.fieldType, PropertyName: field.property, });
                f = (React.createElement(TextField_1.TextField, { id: id_1, key: id_1, label: field.label, required: field.required, className: "S2Input S2TextField", value: this.state.FormValues[id_1], onChange: function (evt, v) {
                        if (v !== undefined) {
                            var o = _this.state.FormValues;
                            o[id_1] = v;
                            _this.setState({ FormValues: o, Submitted: false });
                        }
                    }, onGetErrorMessage: function (value) {
                        return field.required ? _this.validateRequired(id_1, value) : undefined;
                    } }));
                break;
            }
            case "multitext": {
                var id_2 = "fmtxt_" + idx;
                this.formFieldProps.set(id_2, { Id: id_2, Type: field.fieldType, PropertyName: field.property, });
                f = (React.createElement(TextField_1.TextField, { id: id_2, key: id_2, label: field.label, className: "S2Input S2TextField", multiline: true, resizable: true, required: field.required, value: this.state.FormValues[id_2], onChange: function (evt, v) {
                        if (v !== undefined) {
                            var o = _this.state.FormValues;
                            o[id_2] = v;
                            _this.setState({ FormValues: o, Submitted: false });
                        }
                    }, onGetErrorMessage: function (value) {
                        return field.required ? _this.validateRequired(id_2, value) : undefined;
                    } }));
                break;
            }
            case "widemultitext": {
                var id_3 = "fmtxt_" + idx;
                this.formFieldProps.set(id_3, { Id: id_3, Type: field.fieldType, PropertyName: field.property, });
                f = (React.createElement(TextField_1.TextField, { id: id_3, key: id_3, label: field.label, className: "S2Input S2TextField", multiline: true, rows: 10, resizable: true, required: field.required, value: this.state.FormValues[id_3], onChange: function (evt, v) {
                        if (v !== undefined) {
                            var o = _this.state.FormValues;
                            o[id_3] = v;
                            _this.setState({ FormValues: o, Submitted: false });
                        }
                    }, onGetErrorMessage: function (value) {
                        return field.required ? _this.validateRequired(id_3, value) : undefined;
                    } }));
                break;
            }
            case "date": {
                var id1_1 = "fdt_" + idx;
                this.formFieldProps.set(id1_1, { Id: id1_1, Type: field.fieldType, PropertyName: field.property });
                f = (React.createElement("span", { key: "spandt_" + idx },
                    React.createElement(DatePicker_1.DatePicker, { id: id1_1, key: id1_1, label: field.label, isRequired: field.required, className: "S2Input S2DateField", title: "on or after", placeholder: "on or after", value: this.state.FormValues[id1_1], onSelectDate: function (dt) {
                            if (dt !== undefined && dt !== null) {
                                var o = _this.state.FormValues;
                                o[id1_1] = dt;
                                _this.setState({ FormValues: o, Submitted: false });
                            }
                        } })));
                break;
            }
            case "number": {
                var id_4 = "fnum_" + idx;
                this.formFieldProps.set(id_4, { Id: id_4, Type: field.fieldType, PropertyName: field.property });
                f = (React.createElement("span", { key: "spannum_" + idx },
                    React.createElement(TextField_1.TextField, { id: id_4, key: id_4, label: field.label, className: "S2Input S2NumberField", required: field.required, title: "equal to or greater", placeholder: "equal to or greater", value: this.state.FormValues[id_4], onChange: function (evt, v) {
                            if (v !== undefined) {
                                var o = _this.state.FormValues;
                                o[id_4] = v;
                                _this.setState({ FormValues: o, Submitted: false });
                            }
                        }, onGetErrorMessage: function (value) {
                            return field.required ? _this.validateRequired(id_4, value) : undefined;
                        } })));
                break;
            }
            case "boolean": {
                var id_5 = "fbool_" + idx;
                this.formFieldProps.set(id_5, { Id: id_5, Type: field.fieldType, PropertyName: field.property });
                f = (React.createElement(Dropdown_1.Dropdown, { id: id_5, key: id_5, label: field.label, className: "S2Input S2BooleanField", options: [
                        { key: '', text: '' },
                        { key: '1', text: 'Yes' },
                        { key: '0', text: 'No' }
                    ], selectedKey: this.state.FormValues[id_5], onChange: function (evt, v) {
                        if (v !== undefined) {
                            var o = _this.state.FormValues;
                            o[id_5] = v.key;
                            _this.setState({ FormValues: o, Submitted: false });
                        }
                    } }));
                break;
            }
            case "list": {
                var id_6 = "flst_" + idx;
                this.formFieldProps.set(id_6, { Id: id_6, Type: field.fieldType, PropertyName: field.property });
                f = (React.createElement(Dropdown_1.Dropdown, { id: id_6, key: id_6, className: "S2Input S2ListField", placeholder: "Select option(s)", label: field.label, multiSelect: true, required: field.required, options: field.options.map(function (o) {
                        return { key: o, text: o };
                    }), selectedKeys: this.state.FormValues[id_6] !== undefined ? this.state.FormValues[id_6].split(";") : [], onChange: function (evt, v) {
                        var curOptions = _this.state.FormValues[id_6] !== undefined ? _this.state.FormValues[id_6].split(";") : [];
                        var foundIndex = curOptions.indexOf(v === null || v === void 0 ? void 0 : v.key);
                        if ((v === null || v === void 0 ? void 0 : v.selected) && foundIndex === -1)
                            curOptions.push(v === null || v === void 0 ? void 0 : v.key);
                        if (!(v === null || v === void 0 ? void 0 : v.selected) && foundIndex !== -1)
                            curOptions.splice(foundIndex, 1);
                        var o = _this.state.FormValues;
                        o[id_6] = curOptions.join(";");
                        _this.setState({ FormValues: o, Submitted: false });
                    } }));
                break;
            }
        }
        return f;
    };
    RequestForm.prototype.renderCol = function (fields, rowsPerCol, colNumber) {
        var _this = this;
        return (React.createElement(react_bootstrap_1.Col, { key: "col_" + colNumber, lg: "4" }, fields.map(function (f, idx) {
            return _this.renderField(f, (idx + 1) + (colNumber * rowsPerCol));
        })));
    };
    RequestForm.prototype.renderWideCol = function (fields, rowsPerCol, colNumber) {
        var _this = this;
        return (React.createElement(react_bootstrap_1.Col, { key: "col_" + colNumber, lg: "12" }, fields.map(function (f, idx) {
            return _this.renderField(f, (idx + 1) + (colNumber * rowsPerCol));
        })));
    };
    RequestForm.prototype.renderFormRowsx = function () {
        var template = this.props.Template;
        // split the fields across the 3 columns and render
        var RowsPerCol = Math.ceil(template.requestForm.fields.length / 3);
        var rows = [];
        rows.push(this.renderCol(template.requestForm.fields.slice(0, RowsPerCol), RowsPerCol, 0));
        rows.push(this.renderCol(template.requestForm.fields.slice(RowsPerCol, (RowsPerCol * 2)), RowsPerCol, 1));
        rows.push(this.renderCol(template.requestForm.fields.slice(RowsPerCol * 2), RowsPerCol, 2));
        return (React.createElement(react_bootstrap_1.Row, null, rows));
    };
    RequestForm.prototype.renderFormRows = function () {
        var template = this.props.Template;
        // filter out fields that have a value supplied as they won't be
        // presented to the user on the form
        var formFields = template.requestForm.fields.filter(function (f) {
            return (f.value === undefined || f.value === null || f.value.length === 0) ? f : null;
        });
        // process all non-wide fields first and spread across columns
        var nonWideFields = formFields.filter(function (f) {
            return f.fieldType.toLowerCase() !== "widemultitext" ? f : null;
        });
        // split the fields across the 3 columns and render
        var RowsPerCol = Math.ceil(nonWideFields.length / 3);
        var rows = [];
        rows.push(this.renderCol(nonWideFields.slice(0, RowsPerCol), RowsPerCol, 0));
        rows.push(this.renderCol(nonWideFields.slice(RowsPerCol, (RowsPerCol * 2)), RowsPerCol, 1));
        rows.push(this.renderCol(nonWideFields.slice(RowsPerCol * 2), RowsPerCol, 2));
        // process all wide fields last
        var wideFields = formFields.filter(function (f) {
            return f.fieldType.toLowerCase() === "widemultitext" ? f : null;
        });
        rows.push(this.renderWideCol(wideFields, 1, 0));
        return (React.createElement(react_bootstrap_1.Row, null, rows));
    };
    RequestForm.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "S2RequestForm", hidden: !this.props.IsVisible },
            React.createElement(react_bootstrap_1.Container, null,
                React.createElement(react_bootstrap_1.Row, null,
                    React.createElement(react_bootstrap_1.Col, { lg: "9" },
                        React.createElement(Label_1.Label, { className: "S2RequestLabel" }, this.props.GlobalSettings.manualRequestTitle)),
                    React.createElement(react_bootstrap_1.Col, { lg: "3" },
                        React.createElement("span", { className: "S2Buttons" },
                            React.createElement(Spinner_1.Spinner, { size: Spinner_1.SpinnerSize.small, hidden: !this.state.Processing }),
                            React.createElement(Button_1.PrimaryButton, { className: "S2RequestButton", text: "Submit", hidden: this.state.Processing, disabled: this.state.InvalidControlIds.size !== 0, onClick: function () { _this.requestClicked(); } }),
                            React.createElement(Button_1.DefaultButton, { className: "S2ClearButton", text: "Cancel", onClick: function () { _this.clearClicked(); } })))),
                React.createElement(react_bootstrap_1.Row, { hidden: this.state.Processing || !this.state.Submitted },
                    React.createElement(react_bootstrap_1.Col, { lg: "12" },
                        React.createElement(react_1.MessageBar, { onDismiss: function () {
                                _this.clearClicked();
                            }, messageBarType: react_1.MessageBarType.success }, this.props.GlobalSettings.submitSuccess))),
                React.createElement(react_bootstrap_1.Row, null,
                    React.createElement(react_bootstrap_1.Col, { lg: "12" },
                        React.createElement("span", { className: "S2RequestDescription" }, this.props.GlobalSettings.manualRequestDescription))),
                (this.props.Template !== null) ? this.renderFormRows() : null)));
    };
    RequestForm.prototype.validateRequired = function (id, value) {
        var notValid = value === undefined || value.length === 0;
        if (!notValid && this.state.InvalidControlIds.has(id)) {
            var i = this.state.InvalidControlIds;
            this.state.InvalidControlIds.delete(id);
            this.setState({ InvalidControlIds: i });
        }
        else if (notValid && !this.state.InvalidControlIds.has(id)) {
            var i = this.state.InvalidControlIds;
            this.state.InvalidControlIds.set(id, true);
            this.setState({ InvalidControlIds: i });
        }
        //this.setState({ Submitted: false });
        return notValid ? (React.createElement("span", { style: { display: "none" } })) : undefined;
    };
    RequestForm.prototype.setErrorMessage = function (message) {
        if (this.props.OnError)
            this.props.OnError(message);
    };
    RequestForm.prototype.buildJSONForRequest = function () {
        var _this = this;
        var props = {
            Query: this.props.Query
        };
        // set the fixed submission values
        this.props.Template.requestForm.fields.forEach(function (f) {
            if (f.value !== undefined && f.value !== null && f.value.length !== 0) {
                props[f.property] = f.value;
            }
        });
        this.formFieldProps.forEach(function (f) {
            var value = _this.state.FormValues[f.Id];
            if (value !== undefined && value !== null && value.length !== 0) {
                switch (f.Type.toLowerCase()) {
                    default:
                    case "text": {
                        props[f.PropertyName] = value;
                        break;
                    }
                    case "date": {
                        var dt = new Date(Date.parse(value));
                        props[f.PropertyName] = "" + dt.getFullYear() + "-" + _this.zeroPad(dt.getMonth() + 1) + "-" + _this.zeroPad(dt.getDate());
                        break;
                    }
                    case "number": {
                        props[f.PropertyName] = value;
                        break;
                    }
                    case "boolean": {
                        props[f.PropertyName] = value;
                        break;
                    }
                    case "list": {
                        var listprops = [];
                        // NOTE: lists are multi-select and are handled implicitly by
                        // SharePoint search as ORs
                        value.split(";").forEach(function (v, idx) {
                            if (v.length !== 0) {
                                listprops.push(v);
                            }
                        });
                        props[f.PropertyName] = listprops;
                        break;
                    }
                }
            }
        });
        //console.log(`props: ${JSON.stringify(props)}`);
        return JSON.stringify(props);
    };
    RequestForm.prototype.zeroPad = function (num) {
        var s = '';
        if (num < 10) {
            s = '0';
        }
        s += num.toString();
        return s;
    };
    RequestForm.prototype.requestClicked = function () {
        var _this = this;
        this.setState({ Processing: true });
        fetch((window.location.pathname === "/" ? "" : window.location.pathname) + "/api/manualrequest", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ Text: this.buildJSONForRequest() })
        })
            .then(function (response) { return response.text(); })
            .then(function (response) {
            //console.log(`response`, response);
            var success = response === "true";
            if (success) {
                var o_1 = _this.state.FormValues;
                _this.formFieldProps.forEach(function (f) {
                    o_1[f.Id] = "";
                });
                _this.setState({ Submitted: true, FormValues: o_1 });
            }
            else {
                _this.handleError(_this.props.GlobalSettings.submitError);
            }
            _this.setState({ Processing: false });
        })
            .catch(function (e) {
            console.log(e);
            _this.handleError(_this.props.GlobalSettings.submitError);
            _this.setState({ Processing: false });
        });
    };
    RequestForm.prototype.handleError = function (errorMessage) {
        if (this.props.OnError) {
            this.props.OnError(errorMessage);
        }
    };
    RequestForm.prototype.clearClicked = function () {
        var o = this.state.FormValues;
        this.formFieldProps.forEach(function (f) {
            o[f.Id] = "";
        });
        this.setState({ FormValues: o });
        if (this.props.OnClear !== undefined)
            this.props.OnClear();
    };
    return RequestForm;
}(React.Component));
exports.default = RequestForm;
//# sourceMappingURL=RequestForm.js.map